import { render, staticRenderFns } from "./AnswerScore.vue?vue&type=template&id=d2c98d74&scoped=true"
import script from "./AnswerScore.vue?vue&type=script&lang=js"
export * from "./AnswerScore.vue?vue&type=script&lang=js"
import style0 from "./AnswerScore.vue?vue&type=style&index=0&id=d2c98d74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c98d74",
  null
  
)

export default component.exports